// src/config/api.js
const isDevelopment = process.env.NODE_ENV === 'development';
const isElectron = window.location.protocol === 'file:';

const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 
            (isElectron ? 'http://garin-server.duckdns.org:3001' : 
             isDevelopment ? 'http://localhost:3001' : 
             'http://garin-server.duckdns.org:3001')
};

export default API_CONFIG;
